import * as types from '../constants/actionTypes';
// import * as auth from '../../tools/auth0.cred';
import * as api from '../tools/apiConfig';
import jQuery from 'jquery';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import resetpasswordComponent from '../components/common/resetPassword';

export function getSpecialistList(data, props) {
	return function (dispatch, getState) {
		dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.GET_SPECIALISTS_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})

			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						response.data.data.specialists = data.user;
						response.data.data.per_page = data.per_page;

						return dispatch({ type: types.GET_SPECIALISTS_LIST, specialistList: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
			});
	}
}

export function getSpecialistAllAvailabilityAddresses(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALISTS_ALL_AVAILABILITY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						response.data.data.specialists = data.user;
						response.data.data.per_page = data.per_page;
						return dispatch({ type: types.GET_SPECIALISTS_LIST, specialistList: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
			});
	}
}


export function getSpecialistsAssistant(data, props) {
	return function (dispatch, getState) {
		dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.GET_SPECIALISTS_ASSISTANT_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})

			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						// response.data.data.specialists = data.user;
						// response.data.data.per_page = data.per_page;

						return dispatch({ type: types.GET_SPECIALISTS_ASSISTANT_LIST, specialistListAssistant: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
			});
	}
}

export function getSpecialistDetails(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_DETAIL, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					if (data) {
						
						return dispatch({ type: types.GET_SPECIALIST_DETAIL, specialistDetails: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
			});
	}
}
export function getSpecializationList(props) {

	return function (dispatch, getState) {
		axios.get(api.GET_SPECIALIZATION_LIST, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {

					return dispatch({ type: types.GET_SPECIALIZATION_LIST, specializationList: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
				else {
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
			});
	}
}
export function deleteImageProfile(data, props) {

	return function (dispatch, getState) {
		axios.post(api.DELETE_PROFILE_IMAGE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// toast.info(response.data.message);
					// toast.info("Image Removed")
					let user = JSON.parse(localStorage.getItem('user'));
					user.image = response.data.data.profileImage;
					user.tempImage = response.data.data.profileImage;
					localStorage.setItem('user', JSON.stringify(user));
					let userDetail = {
						userId: localStorage.getItem('userId')
					}
					axios.post(api.GET_SPECIALIST_PROFILE, userDetail, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {

								return dispatch({ type: types.GET_SPECIALIST_PROFILE, specialistProfile: response.data.data });
							}
						})
						.catch(function (error) {
						});
				}
			})
			.catch(function (error) {
			});
	}
}
export function uploadSpecialistImage(data, props) {
	return function (dispatch, getState) {
		const formdata = new FormData();
		formdata.append('file', data.file);
		formdata.append('userId', data.userId);
		axios.post(api.UPLOAD_SPECIALIST_IMAGE, formdata, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token

			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					let user = JSON.parse(localStorage.getItem('user'));
					user.image = response.data.data;
					user.tempImage = response.data.data;
					localStorage.setItem('user', JSON.stringify(user));
					// toast.info(response.data.message);
					// toast.info("Image Uploaded")
					let obj = {
						userId: localStorage.getItem('userId')
					}
					// return dispatch({ type: types.GET_PATIENT_IMAGE, latestPatientImage: response.data.data });
					axios.post(api.GET_SPECIALIST_PROFILE, obj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								user.tempImage = response.data.data.tempProfileImage;
								localStorage.setItem('user', JSON.stringify(user));
								return dispatch({ type: types.GET_SPECIALIST_PROFILE, specialistProfile: response.data.data });
							}
						})
						.catch(function (error) {
						});
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toast.error(response.data.message);
				}
				else {
					toast.error(response.data.message);
				}
			})
			.catch(function (error) {
				
			});
	}
}

export function getExperienceList(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_EXPERIENCE_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_EXPERIENCE_LIST, experienceList: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}


export function getSubSpecializationList(data, props) {

	return function (dispatch, getState) {
		axios.post(api.GET_SUBSPECIALIZATION_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_SUBSPECIALIZATION_LIST, subSpecializationList: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function getAppointmentsForMonth(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_APPOINTMENTS_FOR_MONTH, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_APPOINTMENTS_FOR_MONTH, appointments: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function getCountriesList() {

	return function (dispatch, getState) {
		axios.get(api.GET_COUNTRIES_LIST, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_COUNTRIES_LIST, countryList: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function getAppointmentsForDay(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_APPOINTMENTS_FOR_DAY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_APPOINTMENTS_FOR_DAY, dayappointments: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function addPrescriptionImages(data, props) {
	const formdata = new FormData();
	formdata.append('file', data.file)
	formdata.append('type', data.type)
	formdata.append('availabilityId', data.availabilityId)
	formdata.append('doctorId', data.doctorId)
	return function (dispatch, getState) {
		axios.post(api.ADD_PRESCRIPTION_IMAGE, formdata, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					var obj = {
						token: data.userToken,
						doctorId: data.doctorId
					}
					axios.post(api.GET_SPECIALISTS_ALL_AVAILABILITY, obj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								if (data) {
									response.data.data.specialists = data.user;
									response.data.data.per_page = data.per_page;
									return dispatch({ type: types.GET_SPECIALISTS_LIST, specialistList: response.data.data, prescriptionData: response.data.data })
								}
							} else if (response.data.code == 402) {
								localStorage.clear();
								props.history.push('/');
								toastr.error(response.data.message);
							}
						})

					// return dispatch({ type: types.GET_PRESCRIPTION_DATA, subSpecializationList: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function addPrescriptionData(data, props) {
	// var formData = new FormData();
	// formData.append('signatureImage', data.signatureImage)
	// formData.append('logoImage', data.logoImage)
	// formData.append('availabilityId', data.availabilityId)
	// formData.append('doctorId', data.doctorId)
	return function (dispatch, getState) {

		axios.post(api.ADD_PRESCRIPTION_DATA, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// 
					toast.info("Prescription updated successfully");
					var obj = {
						token: data.userToken,
						doctorId: data.doctorId
					}

					localStorage.setItem("prescriptionImage", response.data.data.signatureImage)
					axios.post(api.GET_SPECIALISTS_ALL_AVAILABILITY, obj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {

							if (response.data.code == 200) {
								if (data) {

									response.data.data.specialists = data.user;
									response.data.data.per_page = data.per_page;
									
									return dispatch({ type: types.GET_SPECIALISTS_LIST, specialistList: response.data.data, prescriptionData: response.data.data })
								}
							} else if (response.data.code == 402) {
								localStorage.clear();
								props.history.push('/');
								toastr.error(response.data.message);
							}
						})

					// return dispatch({ type: types.GET_PRESCRIPTION_DATA, subSpecializationList: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

// export function addPrescriptionData(data, props) {
// 	

// 	var formData = new FormData();
// 	formData.append('signatureImage', data.signatureImage)
// 	formData.append('logoImage', data.logoImage)
// 	formData.append('availabilityId', data.availabilityId)
// 	formData.append('doctorId', data.doctorId)
// 	return function (dispatch, getState) {
// 		axios.post(api.ADD_PRESCRIPTION_DATA, formData, {
// 			headers: {
// 				'Content-Type': 'application/json',
// 				'Authorization': 'Bearer ' + localStorage.token
// 			}
// 		})
// 			.then(function (response) {
// 				if (response.data.code == 200) {
// 					var obj = {
// 						token: data.userToken,
// 						doctorId: data.doctorId
// 					}
// 					axios.post(api.GET_SPECIALISTS_ALL_AVAILABILITY, obj, {
// 						headers: {
// 							'Content-Type': 'application/json',
// 							'Authorization': 'Bearer ' + localStorage.token
// 						}
// 					})
// 						.then(function (response) {
// 							if (response.data.code == 200) {
// 								if (data) {
// 									response.data.data.specialists = data.user;
// 									response.data.data.per_page = data.per_page;
// 									return dispatch({ type: types.GET_SPECIALISTS_LIST, specialistList: response.data.data, prescriptionData: response.data.data })
// 								}
// 							} else if (response.data.code == 402) {
// 								localStorage.clear();
// 								props.history.push('/');
// 								toastr.error(response.data.message);
// 							}
// 						})

// 					// return dispatch({ type: types.GET_PRESCRIPTION_DATA, subSpecializationList: response.data.data });
// 				}
// 			})
// 			.catch(function (error) {
// 			});
// 	}
// }

export function getStateList(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_STATES_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_STATES_LIST, stateList: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}


export function saveSpecialistProfile(data, props) {
	
	return function (dispatch, getState) {
		axios.post(api.SAVE_SPECIALIST_PROFILE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				// debugger // eslint-disable-line
				if (response.data.code == 200) {
					// localStorage.setItem('user', JSON.stringify(response.data.data));

					// props.history.push('/specialist/my-appointment');
					// props.history.push('/specialist/my-profile');
					toast.info("Changes Saved");
					// if (data.isVettingTriggered)
						// props.history.push('/specialist/my-documents')
					// window.location.reload(true);

					// toast.info('hkk');
					let userDetail = {
						userId: localStorage.getItem('userId')
					}
					axios.post(api.GET_SPECIALIST_PROFILE, userDetail, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {

								return dispatch({ type: types.GET_SPECIALIST_PROFILE, specialistProfile: response.data.data });
							}
						})
						.catch(function (error) {
						});

					

				} else {
					toast.error('Server is busy please try after some time');
				}

			})
			.catch(function (error) {
				console.log(error)
			});
	}
}

export function getSpecialistProfileData(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_PROFILE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_SPECIALIST_PROFILE, specialistProfile: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function saveAvailability(data, props) {
	
	return function (dispatch, getState) {
		// let apiRoute = data.saveNewClinic ? api.SAVE_AVAILABILITY : api.SAVE_TEMP_AVAILABILITY;
		console.log(props)
		let apiRoute = data.saveNewClinic ? api.SAVE_AVAILABILITY : api.SAVE_AVAILABILITY;
		axios.post(apiRoute, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					
					var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
					// toast.info(nextProps.successMsg);

					if (user.availabilityCount == 0) {
						user.availabilityCount = 1
					}
					if (data.addressChange == true) {
						user.isVerified = '1'
					}
					localStorage.setItem('user', JSON.stringify(user));
					let dataObj = {
						userId: localStorage.getItem('userId')
					}

					if(data.clinicBannerObj && !props.clinicBannerImageDeleted){
						data.clinicBannerObj.clinicId = response.data.data
						// console.log(data.clinicBannerObj)

						const formdata = new FormData();
						formdata.append('file', data.clinicBannerObj.file);
						formdata.append('userId', dataObj.userId);
						formdata.append('clinicId',response.data.data)
						console.log(formdata)
						axios.post(api.UPDATE_CLINIC_BANNER_IMAGE, formdata,{
							headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + localStorage.token
							}
						})
						.then(function(res){
							console.log(res)

							axios.post(api.GET_AVAILABILITY, dataObj, {
								headers: {
									'Content-Type': 'application/json',
									'Authorization': 'Bearer ' + localStorage.token
								}
							})
								.then(function (response2) {
									if (response2.data.code == 200) {
										console.log(response2)
										if(props.editClinic === true){
											toast.info("Clinic Updated");
										}
										else{
		
											toast.info("Clinic Added");
											console.log(response2.data.data)
										}
										return dispatch({ type: types.GET_AVAILABILITY, clinicInfo: response2.data.data, successMsg: response.data.message });
									}
								})
								.catch(function (error) {
								});

						})

					}
					if(props.clinicBannerImageDeleted == true){
						console.log('inside delete')
						let dataObj = {
							userId: localStorage.getItem('userId'),
							clinicId: response.data.data,
						}
						console.log(dataObj)








						axios.post(api.DELETE_CLINIC_BANNER_IMAGE,dataObj, {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + localStorage.token
							}
						})
						.then(function (response3) {
							console.log('hi',response3.data)
							if(response3.data.code == 200){
								
								let dataObj = {
									userId: localStorage.getItem('userId')
								}
								axios.post(api.GET_AVAILABILITY, dataObj, {
									headers: {
										'Content-Type': 'application/json',
										'Authorization': 'Bearer ' + localStorage.token
									}
								})
									.then(function (response4) {
										if(props.editClinic === true){
											toast.info("Clinic Updated");
										}
										else{
											toast.info("Clinic Added");
										}
										if (response4.data.code == 200) {
											return dispatch({ type: types.GET_AVAILABILITY, clinicInfo: response4.data.data });
										}
									})
									.catch(function (error) {
									});
				
							}
						})
						.catch(function(error){
							console.log(error)
						});










					}




					else{

						axios.post(api.GET_AVAILABILITY, dataObj, {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + localStorage.token
							}
						})
							.then(function (response2) {
								if (response2.data.code == 200) {
									console.log(response2)
									if(props.editClinic === true){
										toast.info("Clinic Updated");
									}
									else{
	
										toast.info("Clinic Added");
										console.log(response2.data.data)
									}
									return dispatch({ type: types.GET_AVAILABILITY, clinicInfo: response2.data.data, successMsg: response.data.message });
								}
							})
							.catch(function (error) {
							});

					}
				
				}
			})
			.catch(function (error) {
			});
	}
}


export function checkZipCode(data, props) {
	return function (dispatch, getState) {
		axios.post(api.CHECK_ZIPCODE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				

				if (response.data.code == 200) {
					let data = {
						lat: response.data.data.latitude,
						lon: response.data.data.longitude
					}
					// timezone(data, props)
					return dispatch({ type: types.CHECK_ZIPCODE, zipcodeInfo: response.data.data });

				}
			})
			.catch(function (error) {
			});
	}
}


export function deleteAvailability(data, props) {
	return function (dispatch, getState) {
		axios.post(api.DELETE_AVAILABILITY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					let dataObj = {
						userId: localStorage.getItem('userId')
					}
					axios.post(api.GET_AVAILABILITY, dataObj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (responseAvail) {
							if (responseAvail.data.code == 200) {
								toast.info('Clinic Deleted');
								console.log(responseAvail.data.data)
								return dispatch({ type: types.GET_AVAILABILITY, clinicInfo: responseAvail.data.data });
							} else {
								toast.error('Server is busy please try after some time');
							}
						})
						.catch(function (error) {
						});

				}
			})
			.catch(function (error) {
			});
	}
}

export function getAvailabilitySlot(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_AVAILABILITY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_AVAILABILITY, clinicInfo: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function getSpecialistPatients(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_PATIENTS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_SPECIALIST_PATIENTS, specialistPatients: response.data });
				}
			})
			.catch(function (error) {
			});
	}
}


export function getOtherConsultationAddress(data, props) {
	return function (dispatch, getState) {
		dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: '' })
		axios.post(api.GET_OTHER_CONSULTATION_ADDRESS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_OTHER_CONSULTATION_ADDRESS, otherConsultationAddress: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function getMyFeedback(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_MY_FEEDBACK, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_MY_FEEDBACK, myFeedback: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}


export function getRatingDetail(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_MY_FEEDBACK_DETAIL, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_MY_FEEDBACK_DETAIL, myFeedbackDetail: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function respondToPatient(data, props) {
	return function (dispatch, getState) {
		axios.post(api.RESPOND_TO_PATIENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					var obj = {
						doctorId: localStorage.getItem('userId'),
						count: 10,
						page: 1
					}
					axios.post(api.GET_MY_FEEDBACK, obj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								return dispatch({ type: types.GET_MY_FEEDBACK, myFeedback: response.data.data });
							}
						})
						.catch(function (error) {
						});



				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function updateSpecialistVerification(data, props) {
	return function (dispatch, getState) {
		axios.post(api.UPDATE_SPECIALIST_VERIFICATION, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function missedDocuments(data, props) {
	return function (dispatch, getState) {
		axios.post(api.MISSED_DOCUMENTS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function verifySpecialistStripeAcc(data, props) {
	return function (dispatch, getState) {
		axios.post(api.VERIFY_SPECIALIST_STRIPE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					toast.info(response.data.message);
					props.history.push('/specialist/my-settings')
					return dispatch({ type: types.VERIFY_SPECIALIST_STRIPE, appointmentList: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getSpecialistStripeDetails(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_STRIPE_DETAILS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				

				if (response.data.code == 200) {
					// toast.info(response.data.message);
					props.history.push('/specialist/my-settings')
					return dispatch({ type: types.GET_SPECIALIST_STRIPE_DETAILS, stripeDetails: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function deleteDoctorAccount(data, props) {
	return function (dispatch, getState) {
		axios.post(api.DELETE_DOCTOR_ACCOUNT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// return dispatch({ type: types.DELETE_USER_ACCOUNT, userNotifications: response.data.data });
					props.history.push('/')
				}
			})
			.catch(function (error) {
			});
	}
}


export function editRatingBySpecialist(data, props) {
	return function (dispatch, getState) {
		axios.post(api.EDIT_FEEDBACK_SPECIALIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}
export function currencychange(data, props) {
	var to = localStorage.getItem('currency')
	return function (dispatch, getState) {

		console.log("amount to conver", data)
		axios.get("https://data.fixer.io/api/convert?access_key=6c8cc59a62c21444cf9ad772559e416e&from=" + data.base + "&to=" + to + "&amount=" + data.amount)
			.then(function (response) {
				if (response) {
					
					return dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: response.data })
				}

				// 
			}).catch(function (error) {
				

				toast.error(error);
			});
	}
}


export function getAvgRatingByQuestions(data, props) {

	return function (dispatch, getState) {
		dispatch({ type: types.GET_CONVERTED_CURRENCY, convertedCurrency: null })

		axios.post(api.GET_QUESTION_RATING, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.GET_QUESTION_RATING, questionRatings: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}
export function addCurrencyFilter(data, props) {

	return function (dispatch, getState) {

		axios.post(api.ADD_CURRENCY_FILTER, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {

					toast.info('Data saved successfully');

					axios.post(api.LIST_CURRENCY_FILTER, data, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {

								if (data) {
									return dispatch({ type: types.LIST_CURRENCY_FILTER, listcurrencyFilter: response.data.data })
								}
							} else if (response.data.code == 402) {
							}
						})
						.catch(function (error) {
						});
					if (data) {
						return dispatch({ type: types.ADD_CURRENCY_FILTER, currencyFilter: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}

export function listCurrencyFilter(data, props) {

	return function (dispatch, getState) {

		axios.post(api.LIST_CURRENCY_FILTER, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.LIST_CURRENCY_FILTER, listcurrencyFilter: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
				

			});
	}
}

export function getDetailsForSpecialistAvailability(data) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_DETAIL_FOR_BLOCKING, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// localStorage.setItem('availableId',)
					
					return dispatch({
						type: types.GET_SPECIALIST_DETAIL_FOR_BLOCK,
						specialistDetail: response.data.data
					});
				}
			})
			.catch(function (error) {

			});
	}
}

export function getSpecialistBlocksList(data, props) {
	return function (dispatch, getState) {
		
		axios.post(api.GET_SPECIALIST_BLOCKINGS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// localStorage.setItem('availableId',)
					
					return dispatch({
						type: types.GET_SPECIALIST_BLOCKINGS,
						specialistBlockings: response.data.data
					});
				}
			})
			.catch(function (error) {
				
			});
	}
}

export function createTicket(data) {
	return function (dispatch, getState) {
		axios.post(api.CREATE_TOKEN, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					// localStorage.setItem('availableId',)
					
					return dispatch({
						type: types.GET_SPECIALIST_BLOCKINGS,
						specialistBlockings: response.data.data
					});
				}
			})
			.catch(function (error) {
				
			});
	}
}

export function deleteRecurringEvents(data, props) {
	return function (dispatch, getState) {
		axios.post(api.DELETE_EVENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					// localStorage.setItem('availableId',)
					// 
					// let obj = {
					// 	userToken: userToken,
					// 	specialistId: specialistId,
					// 	userlocation: moment.tz.guess()
					// };
					axios.post(api.GET_SPECIALIST_BLOCKINGS, data, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								// localStorage.setItem('availableId',)
								
								return dispatch({
									type: types.GET_SPECIALIST_BLOCKINGS,
									specialistBlockings: response.data.data
								});
							}
						})
					// getSpecialistBlocksList(data, props);
					// return dispatch({
					// 	type: types.GET_SPECIALIST_BLOCKINGS,
					// 	specialistBlockings: response.data.data
					// });
				}
			})
			.catch(function (error) {
				
			});
	}
}
export function saveLanguageToSpecialist(data, props) {
	return function (dispatch, getState) {
		axios.post(api.ADD_LANGUAGE_TO_SPECIALIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					
					return dispatch({
						type: types.GET_SPECIALIST_BLOCKINGS,
						specialistBlockings: response.data.data
					});
				}
			})
			.catch(function (error) {
				
			});
	}
}
export function getSpecialistInfoForAppointment(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_DETAIL_FOR_APPOINTMENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({
						type: types.SPECIALIST_DETAIL_FOR_APPOINTMENT,
						specialistDetailForAppointment: response.data.data
					});
				}
			})
			.catch(function (error) {
				
			});
	}
}

export function changeSpecialistEmail(data, history) {
	return function (dispatch, getState) {
		axios.post(api.CHANGE_SPECIALIST_EMAIL, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					setTimeout(() => {
						localStorage.clear();
						history.push('/')
					}, 9000);
					return dispatch({ type: types.SPECIALIST_EMAIL_CHANGE_SUCCESS})
					// toast.info(response.data.message);
				
				} 
				else {
					toast.error(response.data.message);
				}
			})
			.catch(function (error) {
				
			});
	}
}

export function resetChangingEmailSuccessMsg() {
	return function (dispatch, getState) {
	    return dispatch({ type: types.RESET_SPECIALIST_EMAIL_CHANGE_SUCCESS})
	};
}


export function getConditionalProcedureMappingList(data) {

	return function (dispatch, getState) {
		axios.get(api.GET_CONDITIONAL_PROCEDURE_MAPPING_LIST, data,{
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_CONDITIONAL_PROCEDURE_MAPPING_LIST, conditionalProcedureMappingList: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toast.error(response.data.message);
				}
				else {
					toast.error(response.data.message);
				}
			})
			.catch(function (error) {
			});
	}
}



export function changeSpecialistPhoneNumber(data){
	console.log(data)
	return function (dispatch, getState){
		axios.post(api.CHANGE_SPECIALIST_PHONE_NO,data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
		.then(function (response) {
			console.log(response.data)
			if(response.data.code == 200){
				toast.info(response.data.message)
				let dataObj = {
					userId: localStorage.getItem('userId')
				}
				axios.post(api.GET_SPECIALIST_PROFILE,dataObj,{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + localStorage.token
					}
				})
				.then(function (response2) {
					if (response2.data.code == 200) {
						console.log(response2.data.data)
						return dispatch({ type: types.GET_SPECIALIST_PROFILE, specialistProfile: response2.data.data });
					}
				})
				.catch(function (error) {
				});



				// return dispatch({type: types.CHANGE_SPECIALIST_PHONE_NO, phoneNumberChanged: response.data})
			}
		})
		.catch(function(error){
			console.log(error)
		});
	}
}


export function changePhoneDisplayOnProfile(data){
	console.log(data)
	return function (dispatch, getState){
		axios.post(api.CHANGE_PHONE_DISPLAY_ON_PROFILE,data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
		.then(function (response) {
			console.log(response.data)
			if(response.data.code == 200){
				if(data.isPhoneDisplayed == false){
					toast.info("Phone Number will now be hidden")
				}

				if(data.isPhoneDisplayed == true){
					toast.info("Phone Number will now be displayed")
				}
				let dataObj = {
					userId: localStorage.getItem('userId')
				}
				axios.post(api.GET_SPECIALIST_PROFILE,dataObj,{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + localStorage.token
					}
				})
				.then(function (response2) {
					if (response2.data.code == 200) {
						console.log(response2.data.data)
						return dispatch({ type: types.GET_SPECIALIST_PROFILE, specialistProfile: response2.data.data });
					}
				})
				.catch(function (error) {
				});

			}
		})
		.catch(function(error){
			console.log(error)
		});
	}
}






export function deleteClinicBannerImage(data){
	return function (dispatch, getState){
		axios.post(api.DELETE_CLINIC_BANNER_IMAGE,data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
		.then(function (response) {
			console.log(response.data)
			if(response.data.code == 200){
				
				let dataObj = {
					userId: localStorage.getItem('userId')
				}
				axios.post(api.GET_AVAILABILITY, dataObj, {
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + localStorage.token
					}
				})
					.then(function (response) {
						if (response.data.code == 200) {
							return dispatch({ type: types.GET_AVAILABILITY, clinicInfo: response.data.data });
						}
					})
					.catch(function (error) {
					});

			}
		})
		.catch(function(error){
			console.log(error)
		});
}}